import { render } from "./VoicemailWrapper.vue?vue&type=template&id=a64c5614"
import script from "./VoicemailWrapper.vue?vue&type=script&lang=js"
export * from "./VoicemailWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__